export default __webpack_public_path__ + "static/2391-5dcf50a7853278b7d01366f405320653.gif";